module.exports = __webpack_public_path__ + "1512b2c40302fb80c06fb4eb8fd728f8.pdf";